/* ============================================================================
   Central portal (qorfechi) site script.
   Pages that keep the previous look (auth, miniapp, landing) load js/legacy.js instead.
   ========================================================================== */
import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard';
import { registerSite } from './site/components';
import { setupNavigate } from './site/navigate';

/* SweetAlert2 (Livewire alerts) is loaded on first use only */
const swal = () => Promise.all([import('sweetalert2'), import('sweetalert2/dist/sweetalert2.min.css')]).then(([module]) => module.default);
window.Swal = { fire: (...args) => swal().then(Swal => Swal.fire(...args)) };
window.Toast = { fire: (options) => swal().then(Swal => Swal.mixin({ toast: true, position: 'top-end', showConfirmButton: false, timer: 3500, timerProgressBar: true }).fire(options)) };

/* Campaign landing pages keep the previous look: their typing effect and lazy images need these two, on those pages only */
if (document.documentElement.hasAttribute('data-legacy')) {
    const [typed] = await Promise.all([import('typed.js'), import('lazysizes')]);
    window.Typed = typed.default;
}

/* Long pages: wrappers marked `x-ignore data-lazy` start their Alpine components about one screen before they scroll
   into view, so opening the page only starts what is on screen (less blocking time on phones) */
const lazy = new IntersectionObserver(entries => entries.forEach(({ isIntersecting, target }) => {
    if (!isIntersecting) return;
    lazy.unobserve(target);
    target.removeAttribute('x-ignore');
    delete target._x_ignore;
    Alpine.initTree(target);
}), { rootMargin: '100% 0px' });
const observeLazy = () => document.querySelectorAll('[data-lazy][x-ignore]').forEach(el => lazy.observe(el));

Alpine.plugin(Clipboard);
registerSite(Alpine);
setupNavigate({ onPage: observeLazy });
Livewire.start();
observeLazy();
